import { SET_FEATURE_FLAGS } from "@constants/action-types";

export const initialState = {
  enable_experimental_features: false,
  enable_testing: false,
  enable_mobile_design: false,
};

const FeatureFlagReducer = (state, action) => {
  switch (action.type) {
    case SET_FEATURE_FLAGS:
      return {
        ...state,
        ...action.value,
      };
    default:
      return state;
  }
};

export default FeatureFlagReducer;
